import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39a4864f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection D-Flex" }
const _hoisted_6 = { class: "M-Auto D-Flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = { class: "DialogSection" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_10 = { class: "DialogSection" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_13 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_CookiesImageInput, {
                Folder: 'Catalogue_Items',
                onSelected: _ctx.CropImage,
                Res: 'D_CatalogItem_Image',
                style: {"border-radius":"var(--rad1)","width":"12em","height":"12em"}
              }, null, 8, ["onSelected"])
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Item Code'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_CatalogItem_Code') && _ctx.MEMRead('D_CatalogItem_Code') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_CatalogItem_Code') && _ctx.MEMRead('D_CatalogItem_Code') !== ''),
              Res: 'D_CatalogItem_Code',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_CookiesDropInputObject, {
              Name: _ctx.Translate('Category'),
              Default: '',
              CreateNew: true,
              Options: _ctx.DialogData.Data.Categories,
              Selectors: ['Name'],
              Res: 'D_CatalogItem_Description'
            }, null, 8, ["Name", "Options"])
          ]),
          (_ctx.DialogData.Editing && _ctx.OriginalData.Description !== '' && _ctx.OriginalData.Description !== _ctx.MEMRead('D_CatalogItem_Description'))
            ? (_openBlock(), _createBlock(_component_CookiesCheckBox, {
                key: 0,
                PreserveMemory: false,
                Res: 'ChangeAllCat',
                Name: _ctx.Translate('Change category for all similar products')
              }, null, 8, ["Name"]))
            : _createCommentVNode("", true),
          _hoisted_11
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Catalogue_Edit': 'Catalogue_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.DialogData.Editing ? _ctx.Translate('Save') : _ctx.Translate('Add')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}